import { render, staticRenderFns } from "./PageBankCard.vue?vue&type=template&id=591c3e03&scoped=true"
import script from "./PageBankCard.vue?vue&type=script&lang=js"
export * from "./PageBankCard.vue?vue&type=script&lang=js"
import style0 from "./PageBankCard.vue?vue&type=style&index=0&id=591c3e03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c3e03",
  null
  
)

export default component.exports